import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import DSInput from '../Input/DSInput.js';
import '../Input/InputImpl.js';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import 'lodash';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../Input/showEllipsis.js';

var DSTextBox = function DSTextBox(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? 255 : _ref$maxLength,
      _ref$minLength = _ref.minLength,
      minLength = _ref$minLength === void 0 ? 0 : _ref$minLength,
      _ref$fluidWidth = _ref.fluidWidth,
      fluidWidth = _ref$fluidWidth === void 0 ? false : _ref$fluidWidth,
      placeholder = _ref.placeholder,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$innerRef = _ref.innerRef,
      innerRef = _ref$innerRef === void 0 ? null : _ref$innerRef,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? undefined : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? undefined : _ref$max,
      _ref$clearable = _ref.clearable,
      clearable = _ref$clearable === void 0 ? false : _ref$clearable,
      _ref$leftComponent = _ref.leftComponent,
      leftComponent = _ref$leftComponent === void 0 ? null : _ref$leftComponent,
      _ref$rightComponent = _ref.rightComponent,
      rightComponent = _ref$rightComponent === void 0 ? null : _ref$rightComponent,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      variant = _ref.variant,
      disableTooltip = _ref.disableTooltip,
      otherProps = _objectWithoutProperties(_ref, ["containerProps", "autoFocus", "disabled", "maxLength", "minLength", "fluidWidth", "placeholder", "value", "hasError", "readOnly", "innerRef", "type", "min", "max", "clearable", "leftComponent", "rightComponent", "required", "variant", "disableTooltip"]);

  return /*#__PURE__*/React.createElement(DSInput, _extends({}, otherProps, {
    "aria-label": otherProps['aria-label'] || 'Text Box',
    autoFocus: autoFocus,
    clearable: clearable,
    containerProps: containerProps,
    disabled: disabled,
    fluidWidth: fluidWidth,
    hasError: hasError,
    innerRef: innerRef,
    leftComponent: leftComponent,
    max: max,
    maxLength: maxLength,
    min: min,
    minLength: minLength,
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    rightComponent: rightComponent,
    role: "textbox",
    type: type,
    value: value,
    variant: variant,
    disableTooltip: disableTooltip
  }));
};

var props = {
  /** inject props at textbox wrapper */
  containerProps: PropTypes.shape({}).description('inject props at textbox wrapper'),

  /**
   * Whether the text box uses auto focus or not
   */
  autoFocus: PropTypes.bool.description('Whether the text box uses auto focus or not'),

  /**
   * Whether the text box is disabled or not
   */
  disabled: PropTypes.bool.description('Whether the text box is disabled or not'),

  /**
   * Max length for the text box
   */
  maxLength: PropTypes.number.description('Max length for the text box'),

  /**
   * Min length for the text box
   */
  minLength: PropTypes.number.description('Min length for the text box'),

  /**
   * Make the content of the text box fit the container or not
   */
  fluidWidth: PropTypes.bool.description('Make the content of the text box fit the container or not'),

  /**
   * Placeholder for the text box
   */
  placeholder: PropTypes.string.description('Placeholder for the text box'),

  /**
   * Default value once the component is initialized
   */
  value: PropTypes.string.description('Default value once the component is initialized'),

  /**
   * Whether the text box has error or not
   */
  hasError: PropTypes.bool.description('Whether the text box has error or not'),

  /**
   * Whether the text box is read only or not
   */
  readOnly: PropTypes.bool.description('Whether the text box is read only or not'),

  /** html min prop for input */
  min: PropTypes.number.description('html min prop for input'),

  /** html max prop for input */
  max: PropTypes.number.description('html max prop for input'),

  /**
   * Whether the text box is clearable or not
   */
  clearable: PropTypes.bool.description('Whether the text box is clearable or not'),

  /**
   * Component to be added at the left side of the text box
   */
  leftComponent: PropTypes.element.description('Component to be added at the left side of the text box'),

  /**
   * Component to be added at the right side of the text box
   */
  rightComponent: PropTypes.element.description('Component to be added at the right side of the text box'),

  /**
   * Whether the text box is required or not
   */
  required: PropTypes.bool.description('Whether the text box is required or not'),

  /**
   * [
   *  'variant-default',
   *  'variant-focus',
   *  'variant-active',
   *  'variant-disabled',
   * ]
   */
  variant: PropTypes.string.description("variant-default','variant-focus','variant-active','variant-disabled'"),

  /** html input type */
  type: PropTypes.string.description('html input type'),

  /** Internal ref */
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).description('internal ref'),

  /** disableTooltip */
  disableTooltip: PropTypes.bool.description('Whether to show a tooltip or not when text does not fit').defaultValue(true)
};
DSTextBox.propTypes = props;
var DSTextBoxWithSchema = describe(DSTextBox);
DSTextBoxWithSchema.propTypes = props;

export default DSTextBox;
export { DSTextBoxWithSchema };
//# sourceMappingURL=DSTextBox.js.map
